import * as React from 'react'
import { GLOBAL_SETTINGS_ASSISTANCE_COLUMN } from '../../state/constants/index'
import { IAssistanceObject } from '../../types'
import AssistanceItemAction from './AssistanceItemAction'

interface IGlobalSettingsMobilityDevicesListItemProps {
  assistance: IAssistanceObject
  categories: any
  columns: GLOBAL_SETTINGS_ASSISTANCE_COLUMN[]
  key: string
}

class AssistanceListItem extends React.Component<IGlobalSettingsMobilityDevicesListItemProps> {
  public render() {
    const { assistance, ...props } = this.props
    return (
      <div className='flex justify-between pl3'>
        <div className='flex col-12'>
          {this.props.columns.includes(GLOBAL_SETTINGS_ASSISTANCE_COLUMN.CATEGORY) && (
            <div className='col-3'>
              {this.props.categories[assistance.categoryId] ? this.props.categories[assistance.categoryId].name : ''}
            </div>
          )}
          {this.props.columns.includes(GLOBAL_SETTINGS_ASSISTANCE_COLUMN.TYPE) && (
            <div className='col-3'>{assistance.type}</div>
          )}
          {this.props.columns.includes(GLOBAL_SETTINGS_ASSISTANCE_COLUMN.INSTRUCTION) && (
            <div className='col-5'>{assistance.instruction}</div>
          )}
          <div className='col-1 flex justify-center'>
            <div>
              <AssistanceItemAction id={assistance.id} />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default AssistanceListItem



// WEBPACK FOOTER //
// ./src/components/global-settings/AssistanceListItem.tsx